import React, { useEffect } from 'react';

import { useAccessToken } from 'Auth';
import isEmpty from 'lodash/isEmpty';

import {
  Stack,
  Typography,
  Iframe,
  Link,
  ToggleButtonGroup,
  ToggleButton,
} from '@gogame/components';
import { useMountedState } from '@gogame/hooks-ts';

const Attachments = ({ data = [] }) => {
  const getAccessToken = useAccessToken();
  const [accessToken, setAccessToken] = useMountedState();
  const [selectedAttachment, setSelectedAttachment] = useMountedState(null);

  useEffect(() => {
    setSelectedAttachment(data[0]);
  }, [data]);

  useEffect(() => {
    getAccessToken().then(setAccessToken);
  }, []);

  const handleAttachmentChange = (_e, value) => {
    data.forEach(async (attachment) => {
      if (attachment.label === value) {
        setSelectedAttachment(attachment);
      }
    });
  };

  return (
    <Stack spacing={2} flex={'1 1 auto'}>
      {data.length && selectedAttachment && data.length !== 1 && accessToken ? (
        <ToggleButtonGroup
          value={selectedAttachment.label}
          onChange={handleAttachmentChange}
        >
          {data.map(({ label }) => (
            <ToggleButton key={label} value={label}>
              {label}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
      ) : null}
      {!isEmpty(selectedAttachment) && accessToken ? (
        selectedAttachment.withPreview ? (
          <Iframe
            src={`${selectedAttachment.src}?access_token=${accessToken}`}
            width={'100%'}
            height={'calc(100vh - 264px)'}
          />
        ) : (
          <Typography noWrap={true}>
            <Link
              href={`${selectedAttachment.src}?access_token=${accessToken}`}
              target={'_blank'}
            >
              {selectedAttachment.name || selectedAttachment.src}
            </Link>
          </Typography>
        )
      ) : (
        <Stack
          alignItems={'center'}
          justifyContent={'center'}
          flex={'1 1 auto'}
        >
          <Typography>No attachments</Typography>
        </Stack>
      )}
    </Stack>
  );
};

export default Attachments;
